<template>
    <client-page>
        <sub-visual sh="시설 및 참여" tabActive="코칭스탭" bg="/images/sub/visual/sv2.jpg"> </sub-visual>

        <section class="section">
            <v-container>
                <dept3-tab page="코칭스탭" tabActive="3" />

                <staff-profile-layout v-bind="profile" />
            </v-container>
        </section>
    </client-page>
</template>

<script>
import ClientPage from "@/pages/client/ko/templates/ClientPage.vue";
import SubVisual from "@/components/client/ko/sub/sub-visual.vue";
import Dept3Tab from "@/components/client/ko/sub/dept3-tab.vue";
import SlidePrimary from "@/components/client/ko/sub/sub-slide-primary.vue";
import StaffTop from "@/components/client/ko/sub/sub-staff-top.vue";

import SubStaffTab from "@/components/client/ko/sub/sub-staff-tab.vue";
import StaffProfileLayout from "@/components/client/ko/center/staff-profile-layout.vue";

export default {
    components: {
        ClientPage,
        SubVisual,
        Dept3Tab,
        SlidePrimary,
        StaffTop,

        SubStaffTab,
        StaffProfileLayout,
    },

    data() {
        return {
            profile: [
                {
                    position: "코치",
                    name: "유지인",
                    items: [
                        {
                            subject: "학력",
                            content: [
                                "함양중 - 함양제일고 - 강원대",
                                //
                            ],
                        },
                        {
                            subject: "경력",
                            content: [
                                "엘리트 육상선수",
                                "국가대표 상비군 육상선수 (단거리)",
                                //
                            ],
                        },
                        {
                            subject: "상훈",
                            content: [
                                "전국 소년체전 금메달",
                                "전국체전 금메달 (단거리)",
                                //
                            ],
                        },
                        {
                            subject: "자격",
                            content: [
                                "전문스포츠 지도자 2급",
                                "노인전문스포츠지도자",
                                "스포츠 영양코치",
                                //
                            ],
                        },
                        {
                            subject: "이메일",
                            content: ["jin@uthestar.org"],
                        },
                    ],
                    image: "/images/sub/center/staff/YuJiin.webp",
                },
            ],
        };
    },
};
</script>

<style lang="scss" scoped></style>
